export default "__VITE_ASSET__DP6$3iE8__"